import React from 'react';
import '../App.css'; // Ensure the CSS file is correctly imported

const Header = () => (
  <div className="header">
    <h1>🌟 Full-Stack Development Course (2025 Edition) - Master Full Stack Development!</h1>
    <p>
      🚀 <strong>Live Classes Start on 1st January 2025</strong> (Live + Recorded Sessions)
      <br />
      Become a Full-Stack Developer and unlock a world of opportunities. This comprehensive course will teach you how to build dynamic, end-to-end web applications, from front-end to back-end, with hands-on projects and expert guidance.
    </p>
    <p>
      Are you ready to kickstart your IT career and become a versatile developer? Our Full-Stack Development Course at EduSmartUp offers a curriculum that covers everything you need to know to excel in both front-end and back-end development. You'll learn to create visually stunning user interfaces, master server-side logic, and manage databases, equipping you with the skills to thrive in the competitive tech industry.
    </p>
    
    <section>
      <h3>Why Choose Full-Stack Development?</h3>
      <ul>
        <li>Full-stack developers are highly sought after for their ability to manage every aspect of web development, from design to deployment.</li>
        <li>This versatility makes them valuable in any development team, and demand for their skills continues to grow globally.</li>
      </ul>
    </section>

    <section>
      <h3>Global Demand for Full-Stack Developers:</h3>
      <ul>
        <li><strong>United States:</strong> Over 30,000 job openings with salaries ranging from $80,000 to $120,000 annually.</li>
        <li><strong>India:</strong> Rising demand in IT giants like TCS and Infosys with salaries from ₹6,00,000 to ₹20,00,000 per year.</li>
        <li><strong>Worldwide:</strong> Opportunities in Europe (€50,000 - €90,000), Australia (AUD 80,000 - AUD 130,000), and Canada (CAD 70,000 - CAD 110,000).</li>
      </ul>
    </section>

    <section>
      <h3>Course Overview:</h3>
      <p>
        This 6-month live, instructor-led program is designed for aspiring developers. Learn essential technologies like HTML, CSS, JavaScript, ReactJS, NodeJS, SQL, PHP, Laravel, and more. By the end, you’ll be proficient in both front-end and back-end development, enabling you to build complete web applications from scratch.
      </p>
    </section>

    <section>
      <h3>Technologies Covered:</h3>
      <div>
        <h4>Front-End Development:</h4>
        <ul>
          <li><strong>HTML & CSS:</strong> Build the foundation of web pages and style them beautifully.</li>
          <li><strong>JavaScript:</strong> Make your websites dynamic and interactive.</li>
          <li><strong>ReactJS:</strong> Master this powerful front-end framework to build responsive user interfaces.</li>
          <li><strong>Next.js:</strong> Learn server-side rendering and build SEO-friendly applications.</li>
        </ul>

        <h4>Back-End Development:</h4>
        <ul>
          <li><strong>NodeJS:</strong> Build scalable server-side applications using JavaScript.</li>
          <li><strong>PHP & Laravel:</strong> Learn server-side scripting and create robust web applications.</li>
        </ul>

        <h4>Databases & Storage:</h4>
        <ul>
          <li><strong>MongoDB:</strong> Manage NoSQL databases for high-performance applications.</li>
          <li><strong>SQL & Firebase:</strong> Work with relational databases and integrate real-time solutions.</li>
        </ul>

        <h4>Version Control & Collaboration:</h4>
        <ul>
          <li><strong>Git & GitHub:</strong> Track changes and collaborate on projects.</li>
          <li><strong>Bitbucket:</strong> Explore another version control platform.</li>
        </ul>

        <h4>APIs & Tools:</h4>
        <ul>
          <li><strong>GraphQL:</strong> Query your data efficiently.</li>
          <li><strong>Postman:</strong> Master API testing and integration.</li>
        </ul>
      </div>
    </section>

    <section>
      <h3>Projects & Real-World Applications:</h3>
      <p>
        Throughout the course, work on 6 mini-projects and a comprehensive capstone project. These will include building a portfolio website, e-commerce platform, and more. Apply all the skills learned to create a fully functional web application.
      </p>
    </section>

    <section>
      <h3>Course Highlights:</h3>
      <ul>
        <li>Live Doubts and Clarification Sessions</li>
        <li>Interactive Live Classes</li>
        <li>Hands-on Coding Practice</li>
        <li>Industry Mentorship</li>
        <li>Mock Interviews & Career Support</li>
        <li>Certification</li>
        <li>1-Year LMS Access</li>
        <li>Networking Opportunities</li>
      </ul>
    </section>

    <section>
      <h3>🎉 Limited Time Offer! 🎉</h3>
      <p>
        <strong>Original Fee:</strong> ₹60,000.00
        <br />
        <strong>Offer Price:</strong> ₹5999.00 (Valid till 1st January 2025)
      </p>
      <p>
        Special Offer for Indian Students: Enroll now at just 10% of the original fee! Only the first 100 students will receive a 90% discount.
      </p>
      <p>Don’t miss this chance to transform your passion for coding into a rewarding career. Enroll now and take the first step toward becoming a skilled Full-Stack Developer!</p>
    </section>
  </div>
);

export default Header;
